import { createApp } from "vue";

import App from "@/App.vue";
import { registerPlugins } from "@core/utils/plugins";

// Styles
import "@core/scss/template/index.scss";
import "@styles/styles.scss";
import "./styles/tailwind.css";

const mswStartupTimeoutMs = 2500;

async function bootstrap() {
  if (import.meta.env.VITE_ENABLE_MSW === "true") {
    try {
      const { worker } = await import("@/mocks/browser");
      const startWorker = worker.start({
        onUnhandledRequest: "bypass",
      });

      await Promise.race([
        startWorker,
        new Promise((resolve) => {
          window.setTimeout(resolve, mswStartupTimeoutMs);
        }),
      ]);
    } catch (error) {
      console.warn("Mock service worker failed to start.", error);
    }
  }

  const app = createApp(App);

  registerPlugins(app);

  app.mount("#app");
}

bootstrap();
